'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _lodash = require('lodash');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Distance = require('../Distance');

var _Distance2 = _interopRequireDefault(_Distance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocatorDetails = function PickupLocatorDetails(props) {
  var details = props.details;

  var openingHours = details.opening_hours.map(function (data) {
    return _react2.default.createElement(
      'li',
      { styleName: 'openingRow', key: (0, _lodash.uniqueId)() },
      _react2.default.createElement(
        'div',
        { styleName: 'days' },
        data.day
      ),
      _react2.default.createElement(
        'div',
        { styleName: 'hours' },
        data.hours
      )
    );
  });

  var confirmClick = function confirmClick(e) {
    e.stopPropagation();
    props.confirm(props.details);
    props.close();
  };

  return _react2.default.createElement(
    'div',
    { styleName: 'container' },
    _react2.default.createElement(
      'div',
      { styleName: 'top' },
      _react2.default.createElement(
        'div',
        { styleName: 'text' },
        _react2.default.createElement(
          'header',
          { styleName: 'header' },
          details.name
        ),
        _react2.default.createElement(
          'p',
          { styleName: 'addressLine' },
          details.address
        ),
        _react2.default.createElement(
          'p',
          { styleName: 'addressLine' },
          details.city
        ),
        _react2.default.createElement(
          'p',
          { styleName: 'addressLine' },
          details.postcode
        )
      ),
      _react2.default.createElement(
        'div',
        { styleName: 'marker' },
        _react2.default.createElement(_Distance2.default, { distance: details.distance_in_miles, selected: true })
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'ol',
        { styleName: 'opening' },
        openingHours
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        { styleName: 'accessibility' },
        'This location has ',
        details.disabled_access_code.toLowerCase(),
        ' accessibility.'
      )
    ),
    _react2.default.createElement(
      'div',
      { styleName: 'buttonContainer' },
      _react2.default.createElement('input', {
        styleName: 'button',
        type: 'button',
        value: 'Select location',
        onClick: function onClick(e) {
          return confirmClick(e);
        }
      })
    )
  );
};

PickupLocatorDetails.propTypes = {
  details: _react.PropTypes.shape({
    name: _react.PropTypes.string.isRequired,
    address: _react.PropTypes.string.isRequired,
    postcode: _react.PropTypes.string.isRequired,
    opening_hours: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      day: _react.PropTypes.string.isRequired,
      hours: _react.PropTypes.string.isRequired
    }))
  })
};

exports.default = (0, _reactCssModules2.default)(PickupLocatorDetails, _style2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Details/index.js
// module id = 596
// module chunks = 0